import type { MenuContent } from '@mawkaa/types';
import { UtensilsCrossed } from 'lucide-react';

interface MenuBlockProps {
  content: MenuContent;
  isEditing?: boolean;
}

export function MenuBlock({ content, isEditing }: MenuBlockProps) {
  const { title, categories = [] } = content;

  if (categories.length === 0) {
    return (
      <section className="px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold">{title || 'Notre Menu'}</h2>
          </div>
          <div className="space-y-8">
            {['Entrées', 'Plats', 'Desserts'].map((cat) => (
              <div key={cat}>
                <h3 className="text-xl font-semibold mb-4 pb-2 border-b">{cat}</h3>
                <div className="space-y-4">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="flex justify-between items-start">
                      <div className="flex gap-4">
                        <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
                          <UtensilsCrossed className="w-6 h-6 text-gray-400" />
                        </div>
                        <div>
                          <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
                          <div className="h-3 bg-gray-100 rounded w-48" />
                        </div>
                      </div>
                      <div className="h-4 bg-gray-200 rounded w-16" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          {isEditing && (
            <p className="text-center text-muted-foreground mt-8">
              Ajoutez vos catégories et plats au menu
            </p>
          )}
        </div>
      </section>
    );
  }

  return (
    <section className="px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold">{title}</h2>
        </div>
        <div className="space-y-12">
          {categories.map((category, catIndex) => (
            <div key={catIndex}>
              <h3 className="text-2xl font-semibold mb-6 pb-2 border-b">{category.name}</h3>
              <div className="space-y-6">
                {category.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="flex justify-between items-start gap-4">
                    <div className="flex gap-4 flex-1">
                      {item.image && (
                        <img
                          src={item.image}
                          alt={item.name}
                          className="w-20 h-20 rounded-lg object-cover"
                        />
                      )}
                      <div>
                        <h4 className="font-medium text-lg">{item.name}</h4>
                        {item.description && (
                          <p className="text-muted-foreground mt-1">{item.description}</p>
                        )}
                      </div>
                    </div>
                    <div className="font-semibold text-lg whitespace-nowrap">{item.price}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
